import { create } from "zustand";

interface AdminStore {
  designPageNumber: number | null;
  setDesignPageNumber: (pageNumber: number | null) => void;
  designSearchTerm: string | null;
  setDesignSearchTerm: (term: string | null) => void;
  designIsPrintedFilter: boolean | null;
  setDesignIsPrintedFilter: (value: boolean | null) => void;
  designOnlyFinalizedFilter: boolean | null;
  setDesignOnlyFinalizedFilter: (value: boolean | null) => void;
  designSelectedUserIdFilter: string;
  setDesignSelectedUserIdFilter: (value: string) => void;
}

export const useAdminStore = create<AdminStore>((set, get) => ({
  designPageNumber: null,
  setDesignPageNumber(pageNumber: number | null) {
    set({ designPageNumber: pageNumber });
  },
  designSearchTerm: null,
  setDesignSearchTerm(term : string | null) {
    set({ designSearchTerm: term })
  },
  designIsPrintedFilter: null,
  setDesignIsPrintedFilter(value: boolean | null) {
    set({ designIsPrintedFilter: value });
  },
  designOnlyFinalizedFilter: null,
  setDesignOnlyFinalizedFilter(value: boolean | null) {
    set({ designOnlyFinalizedFilter: value });
  },
  designSelectedUserIdFilter: '',
  setDesignSelectedUserIdFilter(value: string) {
    set({ designSelectedUserIdFilter: value ?? '' });
  },
}));
